const PreliminaryDiagnosis = () => import(/* webpackChunkName: "preliminaryDiagnosis" */ './PreliminaryDiagnosis.vue')

const index = {
  path: 'preliminary/diagnosis',
  name: 'Preliminary Diagnosis',
  component: PreliminaryDiagnosis,
  meta: {
    requiresLogin: true,
    requiresCompany: true,
    permissions: []
  }
}

export default {
  index
}
